<template>
  <div class="pagination">
    <Page :total="meta ? meta.totalCount : 0" show-total
    :page="meta ? meta.currentPage : 0"
     :page-size="meta ? meta.perPage : 0" @on-change="fetch"></Page>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: ['meta'],
  methods: {
    fetch: function (page) {
      this.meta.currentPage = page
      this.$emit('refresh', page)
    }
  }
}
</script>

<style scoped>
.pagination {
  text-align: center;
}
</style>
